/**
 * Frosset oppslag fra gammel DiBK `filId` → galleri-`id` i DiBKs eksterne API.
 *
 * Seksjonselementer lagret før #13788 har DiBKs gamle fil-id i `FilId`. Den nye
 * API-et identifiserer elementer med galleri-`id`, og tallene kolliderer
 * (gammel filId 104 = «Byggegrense», ny id 104 = «Hensynssone»). Nye rader
 * lagres derfor med galleri-id i eget felt (`GallerielementId`), og denne
 * tabellen brukes kun for å tolke gamle rader som ikke er migrert. Skal aldri
 * utvides.
 *
 * Generert fra den tidligere `packages/galleri/src/galleri.json`.
 */
export const LEGACY_FILID_TO_GALLERI_ID: Readonly<Record<number, number>> = Object.freeze({
    40: 8, // Bebygd areal - etter 1. juli 2007 (BYA)
    41: 9, // Bebygd areal - BYA - før 1. juli 2007
    62: 26, // Prosent bebygd areal - %BYA
    98: 6, // Bruttoareal - BRA. Før 1. juli 1997
    99: 7, // Bruksareal - BRA - etter 1.7.1997
    101: 28, // Byggegrense mot sjø
    102: 1, // Byggehøyde = kotehøyde
    103: 2, // Møneretning
    104: 5, // Byggegrense
    105: 4, // Kotehøyde + byggehøyde
    106: 12, // Saltak
    107: 13, // Valmtak
    108: 14, // Mansardtak
    109: 15, // Pulttak
    110: 16, // To takflater/sammensatte pulttak
    111: 17, // Tak med kobbhus/ark
    112: 18, // Tak med ark
    113: 19, // Tak med takopplett
    114: 20, // Tak med altan i skrå flate
    115: 21, // Saltak med tverrfløy
    116: 22, // Saltak med tverrfløy og ulik gesims
    117: 23, // To flate takflater
    118: 24, // Flatt tak med takoppbygg eller inntrukket toppetasje
    119: 10, // Mønehøyde
    120: 11, // Møne- og gesimshøyde
    122: 29, // Veglovens generelle byggegrenser
    123: 27, // Avstand til vei - når byggegrenser ikke er fastsatt
    141: 25, // Ferdig planert terreng
    150: 47, // Møne og gesims
    152: 50, // Gjennomsnittlig planert terreng
    153: 51, // Måle høyde fra gjennomsnittlig terrengnivå
    154: 52, // Parapet
    155: 60, // Terasse
    156: 62, // Frisiktsone
    157: 65, // Innkjøring parallelt til vei
    158: 66, // Innkjøring rett på vei (90grader)
    248: 90, // Terrasse
    249: 91, // Platting
    250: 92, // Veranda
    251: 93, // Balkong
    252: 94, // Underetasje
    253: 95, // Sokkelleilighet
    254: 96, // Murkrone
    255: 97, // Eiendomsgrense
    256: 99, // Plangrense
    257: 100, // Gavl
    258: 101, // Takvinkel
    259: 102, // Formålsgrense
    260: 103, // Halvvalmet tak
    261: 104, // Hensynssone
    262: 105, // Småhus
    263: 106, // Rekkehus
    264: 107, // Kjedehus
    265: 108, // Enebolig
    266: 109, // Fritidsbebyggelse
    271: 110, // Høyde til raft
});
